/* eslint-disable no-console */
import React from 'react';
// @material-ui/core components
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import CreditBundleCreate from 'components/CreditBundle/Create';

const ScreenCreditBundleCreate = () => (
  <GridContainer justify="center">
    <GridItem xs={12} sm={9} md={8} lg={7}>
      <CreditBundleCreate />
    </GridItem>
  </GridContainer>
);

export default ScreenCreditBundleCreate;
